export default {
  pt: {
    'gestaoPendente.selo': 'Gestão pendente',
    'gestaoPendente.dica_one': '{{count}} gestão pendente no módulo de Gestões',
    'gestaoPendente.dica_other': '{{count}} gestões pendentes no módulo de Gestões',
    'gestaoPendente.aviso.titulo': 'Gestão pendente',
    'gestaoPendente.aviso.texto_one': '{{nome}} tem {{count}} gestão pendente no módulo de Gestões.',
    'gestaoPendente.aviso.texto_other': '{{nome}} tem {{count}} gestões pendentes no módulo de Gestões.',
    'gestaoPendente.aviso.segue': 'O aviso não impede a escala. Clique em OK para continuar.',
    'gestaoPendente.aviso.ok': 'OK',
  },
  en: {
    'gestaoPendente.selo': 'Pending management',
    'gestaoPendente.dica_one': '{{count}} pending management action in the Management module',
    'gestaoPendente.dica_other': '{{count}} pending management actions in the Management module',
    'gestaoPendente.aviso.titulo': 'Pending management',
    'gestaoPendente.aviso.texto_one': '{{nome}} has {{count}} pending management action in the Management module.',
    'gestaoPendente.aviso.texto_other': '{{nome}} has {{count}} pending management actions in the Management module.',
    'gestaoPendente.aviso.segue': 'The warning does not block the assignment. Click OK to continue.',
    'gestaoPendente.aviso.ok': 'OK',
  },
  es: {
    'gestaoPendente.selo': 'Gestión pendiente',
    'gestaoPendente.dica_one': '{{count}} gestión pendiente en el módulo de Gestiones',
    'gestaoPendente.dica_other': '{{count}} gestiones pendientes en el módulo de Gestiones',
    'gestaoPendente.aviso.titulo': 'Gestión pendiente',
    'gestaoPendente.aviso.texto_one': '{{nome}} tiene {{count}} gestión pendiente en el módulo de Gestiones.',
    'gestaoPendente.aviso.texto_other': '{{nome}} tiene {{count}} gestiones pendientes en el módulo de Gestiones.',
    'gestaoPendente.aviso.segue': 'El aviso no impide la asignación. Haga clic en OK para continuar.',
    'gestaoPendente.aviso.ok': 'OK',
  },
}
